import { getData, postData, putData, deleteData } from '../FetchApiServices';

export const getAllLookups    = ()           => getData('t2t/vendor-lookups');
export const getLookupByType  = (type)       => getData(`t2t/vendor-lookups/${type}`);
export const createLookup     = (body)       => postData('t2t/vendor-lookups', body);
export const updateLookup     = (id, body)   => putData(`t2t/vendor-lookups/${id}`, body);
export const deleteLookup     = (id)         => deleteData(`t2t/vendor-lookups/${id}`);
